// components/ScorecardDownloadButton.js

import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { CloudDownload } from "@mui/icons-material";
import MDButton from "components/MDButton";
import { getScorecardExport } from "services/api";
import PropTypes from "prop-types";

const ExportButton = ({ onClick, loading, label, sx = {} }) => (
    <MDButton
      variant="contained"
      color="primary"
      startIcon={loading ? null : <CloudDownload />}
      onClick={onClick}
      disabled={loading}
      sx={{
        fontWeight: "bold",
        textTransform: "none",
        borderRadius: "8px",
        boxShadow: 3,
        whiteSpace: "nowrap",
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : label}
    </MDButton>
  );
  
  ExportButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    sx: PropTypes.object,
  };
  

export default ExportButton;
